'use strict';

import React from 'react';

export default function Bid (props) {
  return <div>заявка</div>;
}



// WEBPACK FOOTER //
// ./src/ui/Buttons/Bid.jsx